import React, { useEffect } from 'react';
import WinXP from './WinXP';

const App = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://webneko.net/n20171213.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <WinXP />
    </>
  );
};

export default App;
